/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Rs } from './Rs';

class IdCardLibrary extends Rs {
    constructor() {
        super();
        this.baseUrl += '/idCardLibrary';
    }

    data({ fullName, idCard, currentPage, pageSize } = {}) {
        return super.get('/data', {
            fullName,
            idCard,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, fullName, idCard } = {}) {
        return super.post('/save', {
            id,
            fullName,
            idCard,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }
}

export default new IdCardLibrary();
export { IdCardLibrary };
